module.exports = __webpack_public_path__ + "files/c299b7bb6e8eab958099a0cfd670f4a7.png";